module.exports = __webpack_public_path__ + "facf23e4db82346c2b618adce48424ed.pdf";